/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import UserAchievementList from './UserAchievementList';
import app from 'flarum/forum/app';
export default class AchievementsProfilePage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.user = null;
    this.loading = true;
    this.loadUser(m.route.param('username'));
  }
  content() {
    if (!this.user || this.loading) {
      return m(LoadingIndicator, {
        size: 46
      });
    }
    return m(UserAchievementList, {
      user: this.user
    });
  }
  show(user) {
    super.show(user);
    this.user = user;
    app.store.find('users', user.id(), {
      include: 'userAchievements,userAchievements.achievementLevel,userAchievements.achievement,userAchievements.achievement.category'
    }).catch(() => {
      // already surfaced by app.request's default handler
    }).then(() => {
      // Runs on failure too: leaving `loading` set would pin the page to a spinner.
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/AchievementsProfilePage', AchievementsProfilePage);